import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	featuredCategoryName: {
		id: 'category-selector.featured.category.name',
		defaultMessage: 'Featured',
		description: 'Text for the name of `Featured` category',
	},
	popularCategoryName: {
		id: 'category-selector.popular.category.name',
		defaultMessage: 'Popular',
		description: 'Text for the name of `Popular` category',
	},
	myTemplatesCategoryName: {
		id: 'category-selector.my-templates.category.name',
		defaultMessage: 'My Templates',
		description: 'Text for the name of `My Templates` category',
	},
});
